import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormRhombus: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-rhombus"><path d="M10.5003 1.79298C11.18 0.660271 12.8225 0.66036 13.5022 1.79298L19.0852 11.0996C19.4177 11.6538 19.4177 12.3462 19.0852 12.9004L13.5022 22.207C12.8224 23.3396 11.1799 23.3397 10.5003 22.207L4.91726 12.9004C4.58486 12.3463 4.58489 11.6537 4.91726 11.0996L10.5003 1.79298Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormRhombus;
